import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Control, Controller } from "react-hook-form";

import { DateTime } from "luxon";

import SelectCreatable from "@/common/components/SelectCreatable.tsx";
import { Rating } from "@/common/enums/sharedEnums.ts";

import { DiagnosticReferentialData } from "../../reducers/index.ts";




const DwellingDiagnosticEpdForm = ({
  control,
}: {
  control: Control<DiagnosticReferentialData, any>;
}) => {
  return (
    <>
      <div className="d-flex d-flex-row justify-content-between">
        <h2
          className="fw-bold main-title mb-3"
          style={{
            fontSize: "24px",
          }}
        >
          DPE / GES
        </h2>
      </div>

      <div className="bg-container bg-container-form">
        <div className="d-flex flex-column flex-md-row flex-wrap gap-5">
          <Row className="w-100">
            <Row>
              <h4 className="add-prop-label mb-4">
                Diagnostic de performance énergétique (DPE)
              </h4>
            </Row>
            <Row>
              <Col md={2}>
                <label className="add-prop-label ms-2">Score</label>
                <Controller
                  control={control}
                  name="EPD.energy.class"
                  render={(select) => (
                    <SelectCreatable
                      className="d-flex"
                      defaultValue={{
                        label: select.field.value,
                        value: select.field.value,
                      }}
                      options={Object.values(Rating).map((value: string) => {
                        return { label: value, value: value };
                      })}
                      getValue={(value) => select.field.onChange(value.value)}
                      isMulti={false}
                      creatable={false}
                    />
                  )}
                />
              </Col>

              <Col md={3}>
                <label className="w-100 add-prop-label ms-2">
                  Date intervention
                </label>
                <Controller
                  control={control}
                  name="EPD.energy.interventionDate"
                  render={(dateTime) => (
                    <DatePicker
                      className="add-prop-input date-select mt-2 mt-lg-0 w-100"
                      dateFormat="dd/MM/yyyy"
                      locale="fr"
                      selected={
                        dateTime.field.value
                          ? new Date(dateTime.field.value)
                          : new Date()
                      }
                      onChange={(date) => {
                        dateTime.field.onChange(
                          (date
                            ? DateTime.fromJSDate(date)
                            : DateTime.now()
                          ).toISO(),
                        );
                      }}
                      formatWeekDay={(nameOfDay) =>
                        nameOfDay.toString().toUpperCase().substr(0, 1)
                      }
                    />
                  )}
                />
              </Col>

              <Col md={3}>
                <label className="w-100 add-prop-label ms-2">
                  Valide jusqu’au :
                </label>
                <Controller
                  control={control}
                  name="EPD.energy.validityDate"
                  render={(dateTime) => (
                    <DatePicker
                      className="add-prop-input date-select mt-2 mt-lg-0 w-100"
                      dateFormat="dd/MM/yyyy"
                      locale="fr"
                      placeholderText="Illimité"
                      selected={
                        dateTime.field.value
                          ? new Date(dateTime.field.value)
                          : undefined
                      }
                      onChange={(date) => {
                        dateTime.field.onChange(
                          (date
                            ? DateTime.fromJSDate(date)
                            : DateTime.now()
                          ).toISO(),
                        );
                      }}
                      formatWeekDay={(nameOfDay) =>
                        nameOfDay.toString().toUpperCase().substr(0, 1)
                      }
                    />
                  )}
                />
              </Col>
            </Row>
          </Row>
          <Row className="w-100">
            <Row>
              <h4 className="add-prop-label mb-4">
                Emission de Gaz à effet de Serre (GES)
              </h4>
            </Row>
            <Row>
              <Col md={2}>
                <label className="add-prop-label ms-2">Score</label>
                <Controller
                  control={control}
                  name="EPD.ghg.class"
                  render={(select) => (
                    <SelectCreatable
                      className="d-flex"
                      defaultValue={{
                        label: select.field.value,
                        value: select.field.value,
                      }}
                      options={Object.values(Rating).map((value: string) => {
                        return { label: value, value: value };
                      })}
                      getValue={(value) => select.field.onChange(value.value)}
                      isMulti={false}
                      creatable={false}
                    />
                  )}
                />
              </Col>

              <Col md={3}>
                <label className="w-100 add-prop-label ms-2">
                  Date intervention
                </label>
                <Controller
                  control={control}
                  name="EPD.ghg.interventionDate"
                  render={(dateTime) => (
                    <DatePicker
                      className="add-prop-input date-select mt-2 mt-lg-0 w-100"
                      dateFormat="dd/MM/yyyy"
                      locale="fr"
                      selected={
                        dateTime.field.value
                          ? new Date(dateTime.field.value)
                          : new Date()
                      }
                      onChange={(date) => {
                        dateTime.field.onChange(
                          (date
                            ? DateTime.fromJSDate(date)
                            : DateTime.now()
                          ).toISO(),
                        );
                      }}
                      formatWeekDay={(nameOfDay) =>
                        nameOfDay.toString().toUpperCase().substr(0, 1)
                      }
                    />
                  )}
                />
              </Col>

              <Col md={3}>
                <label className="w-100 add-prop-label ms-2">
                  Valide jusqu’au :
                </label>
                <Controller
                  control={control}
                  name="EPD.ghg.validityDate"
                  render={(dateTime) => (
                    <DatePicker
                      className="add-prop-input date-select mt-2 mt-lg-0 w-100"
                      dateFormat="dd/MM/yyyy"
                      locale="fr"
                      placeholderText="Illimité"
                      selected={
                        dateTime.field.value
                          ? new Date(dateTime.field.value)
                          : undefined
                      }
                      onChange={(date) => {
                        dateTime.field.onChange(
                          (date
                            ? DateTime.fromJSDate(date)
                            : DateTime.now()
                          ).toISO(),
                        );
                      }}
                      formatWeekDay={(nameOfDay) =>
                        nameOfDay.toString().toUpperCase().substr(0, 1)
                      }
                    />
                  )}
                />
              </Col>
            </Row>
          </Row>
        </div>
      </div>
    </>
  );
};

export default DwellingDiagnosticEpdForm;
